import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function CalendarModal({ isOpen, onClose, onDateSelect, selectedDate }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Date</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={1}>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => {
              onDateSelect(date);
            }}
            inline
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
